import { createSelector } from '@reduxjs/toolkit'

const getNotificationStatus = (state) => state.status
const getUser = (state) => state.me

/*
 * Selector for notifications badge.
 */
export const hasUnseenNotificationSelector = createSelector(
  [getNotificationStatus],
  (status) => {
    if (!status) return false
    return !!status.unseen
  }
)

/*
 * Selector for user profile.
 */
export const userIdSelector = createSelector([getUser], (user) =>
  user ? parseInt(user.id, 10) : null
)
